<template>
  <vs-row id="appSettingsPage" vs-type="flex" vs-w="12">
    <vs-row vs-type="flex" vs-w="12" class="mt-4" vs-justify="space-between">
      <vs-col vs-w="6" class="pr-2">
        <div
          v-if="posIpSettings"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">Pos Cihazı Ayarı</span>
          </div>
          <form data-vv-scope="form-pos-ip-settings">
            <vs-row vs-type="flex" vs-w="12" class="mb-4">
              <vs-col :vs-w="posIpSettings.posType == 2 ? 6 : 12">
                <span class="weight-600" style="white-space: nowrap;">Durum :</span><br />
                <vs-switch class="mt-2" v-model="posIpSettings.enable">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
              <vs-col vs-w="6" v-if="posIpSettings.posType == 2">
                <span class="weight-600" style="white-space: nowrap;">Eşleştir :</span><br />
                <vs-button class="mt-1" type="gradient" color="success" icon-pack="feather" icon="icon-link" @click.stop="connectPos(posIpSettings.serialNumber)"></vs-button>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="mb-4">
              <vs-col vs-w="12">
                <span class="weight-600">Entegrasyon Tipi :</span><br />
                <div class="mt-2">
                  <vs-radio v-model="posIpSettings.posType" vs-value="0" class="mr-6" vs-name="footer-type-hidden">REST</vs-radio>
                  <vs-radio v-model="posIpSettings.posType" vs-value="1" class="mr-6" vs-name="footer-type-static">GMP3</vs-radio>
                  <vs-radio v-model="posIpSettings.posType" vs-value="2" class="mr-6" vs-name="footer-type-static">Cloud</vs-radio>
                </div>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                IP Adresi (192.168.1.1)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:
                    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])+$/,
                }"
                name="IP Adresi"
                placeholder="IP Adresi"
                v-model="posIpSettings.deviceUrl"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.IP Adresi")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                Port (7500)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:/^()([1-9]|[1-5]?[0-9]{2,4}|6[1-4][0-9]{3}|65[1-4][0-9]{2}|655[1-2][0-9]|6553[1-5])$/
              }"
                name="Device Port"
                placeholder="Device Port"
                v-model="posIpSettings.devicePort"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.Device Port")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                API Url (https://localhost)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:/^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}$/

                  }"
                name="API URL"
                placeholder="API URL"
                v-model="posIpSettings.apiUrl"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.API URL")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
               API Port (7500)
              </span>
              <vs-input
                v-validate="{
                  required: true,
                  regex:/^()([1-9]|[1-5]?[0-9]{2,4}|6[1-4][0-9]{3}|65[1-4][0-9]{2}|655[1-2][0-9]|6553[1-5])$/
              }"
                name="Api Port"
                placeholder="API Port"
                v-model="posIpSettings.apiPort"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.Api Port")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" class="my-2">
              <span class="weight-600">
                Seri No
              </span>
              <vs-input v-validate="{required:true}"
                name="SerialNumber"
                placeholder="Seri No"
                v-model="posIpSettings.serialNumber"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-pos-ip-settings.SerialNumber")
                }}</span>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-pos-ip-settings.IP Adresi') || errors.has('form-pos-ip-settings.Device Port') || errors.has('form-pos-ip-settings.API URL') || errors.has('form-pos-ip-settings.API Port') || errors.has('form-pos-ip-settings.SerialNumber')"
                color="success"
                @click="submitPosIpSettings"
              >Kaydet
              </vs-button>
            </vs-row>
          </form>
        </div>

        <div
          v-if="posIpSettings"
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1 mt-4"
        >
          <div class="mb-2">
            <span class="text-primary bold text-medium">POS Fiş Nüsha Ayarları</span>
          </div>
          <form data-vv-scope="form-pos-receipt-settings">
            <vs-row vs-type="flex" vs-w="12" class="mb-4">
              <vs-col vs-w="6">
                <span class="weight-600" style="white-space: nowrap;">Müşteri Nüshası :</span><br />
                <vs-switch class="mt-2" v-model="posIpSettings.printCustomerReceipt">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
              <vs-col vs-w="6">
                <span class="weight-600" style="white-space: nowrap;">İşyeri Nüshası :</span><br />
                <vs-switch class="mt-2" v-model="posIpSettings.printMerchantReceipt">
                  <span slot="on">Aktif</span>
                  <span slot="off">Pasif</span>
                </vs-switch>
              </vs-col>
            </vs-row>
            <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                color="primary"
                @click="submitReceiptSettingsToDevice"
              >POS Cihazına Gönder
              </vs-button>
            </vs-row>
          </form>
        </div>
      </vs-col>
      <vs-col vs-type="flex" vs-w="6">
        <div
          class="w-full px-3 py-2 bg-white2 sale-box-shadow half-friendly-border ml-1"
        >
        <div class="mb-2">
            <span class="text-primary bold text-medium">Diğer Pos Cihazları</span>
          </div>
          <form data-vv-scope="form-sub-pos">


          <vs-table :data="posIpSettings.subPosSettings" class="mt-4 w-full">
          <div
            slot="header"
            class="flex flex-wrap-reverse items-center flex-grow justify-between"
          ></div>
          <template slot="thead">
            <vs-th class="w-2/12"> Durum</vs-th>
            <vs-th class="w-2/12"> İsim</vs-th>
            <vs-th class="w-2/12"> Seri No</vs-th>
            <vs-th class="w-3/12"> IP Adresi</vs-th>
            <vs-th class="w-2/12"> İşlem</vs-th>
          </template>
<template slot-scope="{ data }">
            <tbody>
              <vs-tr
                :data="item"
                :key="indextr"
                v-for="(item, indextr) in data"
              >
                <vs-td class="w-2/12">
                  <vs-switch
                    v-model="item.enable"
                  >
                    <span slot="on"></span>
                    <span slot="off">Durum</span>
                  </vs-switch>
                </vs-td>

                <vs-td class="w-2/12">
                  <vs-input
                    id="name"
                    :name="indextr + 1 + '.İsim'"
                    v-validate="'required|min:2|max:60'"
                    v-model="item.name"
                    class="w-full" placeholder="İsim"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('form-sub-pos.' + (indextr + 1) + '.İsim')"
                    >{{
                      errors.first("form-sub-pos." + (indextr + 1) + ".İsim")
                    }}</span
                  >
                </vs-td>
                <vs-td class="w-2/12">
                  <vs-input
                    id="serialNumber"
                    :name="indextr + 1 + '.Seri No'"
                    v-validate="{required:true}"
                    v-model="item.serialNumber"
                    class="w-full" placeholder="Seri No"
                  />
                  <span
                    class="text-danger text-sm"
                    v-show="errors.has('form-sub-pos.' + (indextr + 1) + '.Seri No')"
                    >{{
                      errors.first("form-sub-pos." + (indextr + 1) + ".Seri No")
                    }}</span
                  >
                </vs-td>
                <vs-td class="w-3/12">
                  <vs-input
                v-validate="{
                  required: true,
                  regex:
                    /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])+$/,
                }"
                :name="indextr + 1 + '.IP Adresi'"
                placeholder="IP Adresi"
                v-model="item.deviceUrl"
                class="w-full"
              />
              <span class="text-danger text-sm">{{
                  errors.first("form-sub-pos." + (indextr + 1) + ".IP Adresi")
                }}</span>
                </vs-td>
                <vs-td class="w-2/12">
                  <vs-row vs-type="flex" vs-w="12">
                    <vs-col
                      vs-type="flex"
                      vs-w="6"
                      style="justify-content: center"
                    >
                      <vs-button
                        v-if="!item.isDefault"
                        type="gradient"
                        color="danger"
                        icon-pack="feather"
                        icon="icon-trash"
                        @click.stop="deleteSubPos(item, indextr)"
                      >
                      </vs-button>
                    </vs-col>
                    <vs-col
                      vs-type="flex"
                      vs-w="6"
                      style="justify-content: center"
                    >
                      <vs-button type="gradient" color="success" icon-pack="feather" icon="icon-link" @click.stop="connectPos(item.serialNumber)"></vs-button>
                    </vs-col>
                  </vs-row>
                </vs-td>
              </vs-tr>
            </tbody>
            <vs-button
              class="m-4"
              type="gradient"
              icon-pack="feather"
              icon="icon-plus"
              color="primary"
              @click="addNewSub"
            >
            </vs-button>
          </template>

        </vs-table>
        <vs-row vs-type="flex" vs-w="12" vs-justify="flex-end" class="mt-2">
              <vs-button
                :disabled="errors.has('form-sub-pos.İsim')||errors.has('form-sub-pos.IP Adresi')"
                color="success" @click="submitSubPos"
              >Kaydet
              </vs-button>
            </vs-row>
          </form>
      </div>
      </vs-col>
    </vs-row>
  </vs-row>
</template>

<script>
import { getPosSettings,  setPosSettings, setSubPosSettings } from "@/api/AppSettings";
import { PairPos } from "@/api/PavoCloud";
export default {
  name: "PosSettings",
  data() {
    return {
      isLoaded: false,
      posIpSettings: {
        apiUrl:"",
        apiPort:"",
        deviceUrl:"",
        devicePort:"",
        enable: false,
        branchId:null,
        id:null,
        posType:0,
        printCustomerReceipt:false,
        printMerchantReceipt:false,
        receiptImageEnabled: false,
        receiptJsonEnabled: false,
        receiptTextEnabled: false,
        receiptWidth: "58mm",
        printCustomerReceiptCopy: false,
        enableExchangeRateField: false,
        subPosSettings:[]
      },
    };
  },
  methods: {
    connectPos: async function(serialNumber){
      try{
        let axiosResponse = await PairPos(serialNumber);
        this.$fire({
              title: "Eşleşme İsteği Gönderildi !",
              text: "Doğrulama Kodu : " + axiosResponse.data,
              type: "success",
            });
      }catch(error){
        this.$vs.notify({
          color: "danger",
          title: "Hata !",
          text: "Pos Cihazı Eşleştirilemedi !",
        });
      }
    },
    submitSubPos: async function(){
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let branchId = userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      this.posIpSettings.id = axiosResponse.data.id;
      let checker = await this.$validator.validateAll("form-sub-pos");
      if(checker){
        setSubPosSettings(this.posIpSettings)
            .then((res) => {
              if (res && res.status === 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Pos Cihaz Ayarları Güncellendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Pos Cihaz Ayarları Güncellenemedi !",
                });
              }
            })
            .catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
      }
    },
    deleteSubPos: function(item, index){
      this.posIpSettings.subPosSettings.splice(index, 1);
    },
    addNewSub: function(){
      if (!this.posIpSettings.subPosSettings) {
        this.posIpSettings.subPosSettings = [];
      }
      this.posIpSettings.subPosSettings.push({
        id:0,
        enable:false
      })
    },
    submitPosIpSettings: async function () {
      this.posIpSettings.posType = parseInt(this.posIpSettings.posType);
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let branchId = userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      this.posIpSettings.id = axiosResponse.data.id;
      
      // Ensure PascalCase properties are also updated on this.posIpSettings for backend compatibility
      const camelCaseKeys = [
        'printCustomerReceipt',
        'printMerchantReceipt',
        'receiptImageEnabled',
        'receiptJsonEnabled',
        'receiptTextEnabled',
        'receiptWidth',
        'printCustomerReceiptCopy',
        'enableExchangeRateField'
      ];
      
      camelCaseKeys.forEach(key => {
        const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
        const value = this.posIpSettings[key] !== undefined ? this.posIpSettings[key] : false;
        this.posIpSettings[pascalKey] = value;
      });

      let checker;
      checker = await this.$validator.validateAll("form-pos-ip-settings");
      if (checker) {
          setPosSettings(this.posIpSettings)
            .then((res) => {
              if (res && res.status === 200) {
                this.$vs.notify({
                  color: "success",
                  title: "Başarılı !",
                  text: "Pos Cihaz Ayarları Güncellendi !",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Hata : " + res.status,
                  text: "Pos Cihaz Ayarları Güncellenemedi !",
                });
              }
            })
            .catch(() => {
              this.$vs.notify({
                color: "danger",
                title: "Hata !",
                text: "Sunucu Bağlantı Hatası !",
              });
            });
      }
    },
    submitReceiptSettingsToDevice: async function () {
      this.posIpSettings.posType = parseInt(this.posIpSettings.posType);
      let userInfo = JSON.parse(localStorage.getItem("userInfo"))
      let branchId = userInfo.branch.id
      let axiosResponse = await getPosSettings(branchId);
      this.posIpSettings.id = axiosResponse.data.id;
      
      const camelCaseKeys = [
        'printCustomerReceipt',
        'printMerchantReceipt',
        'receiptImageEnabled',
        'receiptJsonEnabled',
        'receiptTextEnabled',
        'receiptWidth',
        'printCustomerReceiptCopy',
        'enableExchangeRateField'
      ];
      
      camelCaseKeys.forEach(key => {
        const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
        const value = this.posIpSettings[key] !== undefined ? this.posIpSettings[key] : false;
        this.posIpSettings[pascalKey] = value;
      });

      setPosSettings(this.posIpSettings)
        .then((res) => {
          if (res && res.status === 200) {
            this.updateReceiptSettingOnDevice();
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Pos Cihaz Ayarları Güncellenemedi !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    getPosSettings(branchId) {
      this.isLoaded = false;
      getPosSettings(branchId)
        .then((res) => {
          if (res && res.status === 200) {
            this.posIpSettings = Object.assign({
              printCustomerReceipt: false,
              printMerchantReceipt: false,
              receiptImageEnabled: false,
              receiptJsonEnabled: false,
              receiptTextEnabled: false,
              receiptWidth: "58mm",
              printCustomerReceiptCopy: false,
              enableExchangeRateField: false
            }, res.data);

            // Normalize case mismatch between PascalCase (C# backend) and camelCase (Vue templates)
            const camelCaseKeys = [
              'printCustomerReceipt',
              'printMerchantReceipt',
              'receiptImageEnabled',
              'receiptJsonEnabled',
              'receiptTextEnabled',
              'receiptWidth',
              'printCustomerReceiptCopy',
              'enableExchangeRateField'
            ];
            
            camelCaseKeys.forEach(key => {
              const pascalKey = key.charAt(0).toUpperCase() + key.slice(1);
              if (res.data[pascalKey] !== undefined) {
                this.$set(this.posIpSettings, key, res.data[pascalKey]);
              } else if (res.data[key] !== undefined) {
                this.$set(this.posIpSettings, key, res.data[key]);
              }
            });

            this.$nextTick(() => {
              this.isLoaded = true;
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Pos Cihaz Ayarları Bulunamadı !",
            });
          }
        })
        .catch(() => {
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !",
          });
        });
    },
    updateReceiptSettingOnDevice: async function () {
      try {
        let bridgeUrl = process.env.VUE_APP_POS_API;
        if (!bridgeUrl) {
          if (!this.posIpSettings.apiUrl) return;
          bridgeUrl = this.posIpSettings.apiUrl;
          if (this.posIpSettings.apiPort) {
            bridgeUrl += ":" + this.posIpSettings.apiPort;
          }
          if (!bridgeUrl.startsWith("http")) {
            bridgeUrl = "http://" + bridgeUrl;
          }
        }

        const url = bridgeUrl.endsWith('/') ? bridgeUrl + 'set-receipt-info' : bridgeUrl + '/set-receipt-info';

        // Robust payload containing both nested ReceiptInformation and flat receipt properties
        const payload = {
          IpAdress: this.posIpSettings.deviceUrl,
          SerialNumber: this.posIpSettings.serialNumber,
          ReceiptImageEnabled: this.posIpSettings.receiptImageEnabled,
          ReceiptJsonEnabled: this.posIpSettings.receiptJsonEnabled,
          ReceiptTextEnabled: this.posIpSettings.receiptTextEnabled,
          ReceiptWidth: this.posIpSettings.receiptWidth || "58mm",
          PrintCustomerReceipt: this.posIpSettings.printCustomerReceipt,
          PrintMerchantReceipt: this.posIpSettings.printMerchantReceipt,
          PrintCustomerReceiptCopy: this.posIpSettings.printCustomerReceiptCopy,
          EnableExchangeRateField: this.posIpSettings.enableExchangeRateField,

          ReceiptInformation: {
            ReceiptImageEnabled: this.posIpSettings.receiptImageEnabled,
            ReceiptJsonEnabled: this.posIpSettings.receiptJsonEnabled,
            ReceiptTextEnabled: this.posIpSettings.receiptTextEnabled,
            ReceiptWidth: this.posIpSettings.receiptWidth || "58mm",
            PrintCustomerReceipt: this.posIpSettings.printCustomerReceipt,
            PrintMerchantReceipt: this.posIpSettings.printMerchantReceipt,
            PrintCustomerReceiptCopy: this.posIpSettings.printCustomerReceiptCopy,
            EnableExchangeRateField: this.posIpSettings.enableExchangeRateField
          }
        };

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify(payload)
        });

        if (!response.ok) {
          throw new Error(`POS Bağlantı Hatası: HTTP ${response.status}`);
        }

        const resData = await response.json();
        
        const isSuccess = resData && (
          resData.hasError === false || 
          resData.HasError === false || 
          resData.statusCode === 200 || 
          resData.StatusCode === 200 || 
          resData.status === "Success" || 
          resData.Status === "Success" || 
          resData.success === true ||
          resData.Success === true ||
          resData.statusId === 4 ||
          resData.StatusId === 4
        );

        const responseMsg = resData ? (resData.message || resData.Message || resData.description || resData.Description) : null;

        if (isSuccess) {
          this.$vs.notify({
            color: "success",
            title: "POS Senkronizasyonu Başarılı !",
            text: responseMsg || "Fiş ayarları cihaza başarıyla gönderildi ve uygulandı.",
          });
          this.$fire({
            title: "Başarılı !",
            text: responseMsg || "POS Nüsha ayarları başarıyla cihaza uygulandı.",
            type: "success"
          });
        } else {
          this.$vs.notify({
            color: "warning",
            title: "POS Cihaz Uyarısı !",
            text: responseMsg || "Cihaz ayarları uygulamayı reddetti.",
          });
          this.$fire({
            title: "Cihaz Uyarısı !",
            text: responseMsg || "Ayarlar POS servisine ulaştı ancak uygulanamadı.",
            type: "warning"
          });
        }

        console.log("POS Receipt Settings synced to device:", payload.ReceiptInformation, "Response:", resData);
      } catch (error) {
        console.error("Failed to update receipt setting on device:", error);
        
        let alertText = "POS Bridge bağlantısı başarısız oldu. Servisin çalıştığından ve IP/Port bilgilerinin doğru olduğundan emin olun. Hata: " + (error.message || "");
        if (error.message && error.message.includes("HTTP 404")) {
          alertText = "POS Bridge bağlantısı başarısız oldu (Hata: HTTP 404). Lütfen yerel bilgisayarınızdaki POS Entegrasyon servisini güncelleyin. Eski servis sürümlerinde bu özellik desteklenmemektedir.";
        }

        this.$vs.notify({
          color: "danger",
          title: "POS Ayar Gönderim Hatası !",
          text: error.message || "Lokal POS servisine bağlanılamadı.",
        });
        this.$fire({
          title: "Bağlantı Başarısız !",
          text: alertText,
          type: "error"
        });
      }
    },
  },
  created: async function () {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"))
    let branchId = userInfo.branch.id
    await this.getPosSettings(branchId);
  },
};
</script>

<style></style>
